<main class="registrations-page" dir="rtl">
  <div class="page-content">
    <a class="back-link" routerLink="/">
      <mat-icon aria-hidden="true">chevron_right</mat-icon>
      بازگشت
    </a>

    <header class="page-header">
      <div>
        <h1>ثبت‌نامی‌های من</h1>
        <p>فهرست خودروهایی که ثبت کرده‌اید</p>
      </div>
    </header>

    <section class="registrations-panel" aria-label="فهرست ثبت‌نامی‌ها">
      <div class="panel-toolbar">
        <div>
          <h2>فهرست ثبت‌نام‌ها</h2>
          <p>برای دیدن جزئیات، یک مورد را انتخاب کنید.</p>
        </div>
        <div class="search-field">
          <mat-icon aria-hidden="true">search</mat-icon>
          <input type="search" [(ngModel)]="searchKey" aria-label="جستجو در ثبت‌نامی‌ها" placeholder="جستجوی نام یا موبایل" />
        </div>
      </div>

      <ng-container *ngIf="myRegistrations$ | async as registrations; else waiting">
        <ng-container *ngIf="registrations | filter: searchKey : ['strName', 'strFamily', 'strMobile'] as filtered">
          <div class="results-heading" *ngIf="filtered.length">
            <span>ثبت‌نام‌ها</span><span>{{ filtered.length | faNum }} مورد</span>
          </div>
          <div class="registration-list" *ngIf="filtered.length; else emptyResults">
            <button type="button" class="registration-item" *ngFor="let registration of filtered; let index = index" (click)="openDtailsDialog(registration)">
              <span class="item-number">{{ index + 1 | faNum }}</span>
              <span class="item-main">
                <span class="item-name">{{ registration.strName }} {{ registration.strFamily }}</span>
                <span class="item-meta"><span dir="ltr">{{ registration.strMobile || '—' }}</span></span>
              </span>
              <span class="item-date"><span class="item-label">تاریخ ثبت</span><span dir="ltr">{{ registration.strRegisterDateTime || '—' }}</span></span>
              <span class="item-status"><span class="item-label">وضعیت</span><span class="status-badge">{{ registration.strInstallationStatus || '—' }}</span></span>
              <mat-icon class="item-arrow" aria-hidden="true">chevron_left</mat-icon>
            </button>
          </div>
          <ng-template #emptyResults>
            <div class="empty-state"><mat-icon aria-hidden="true">search_off</mat-icon><p>{{ searchKey ? 'موردی با این جستجو پیدا نشد.' : 'هنوز ثبت‌نامی وجود ندارد.' }}</p></div>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-template #waiting><div class="empty-state" role="status"><p>{{ loadError ? 'دریافت فهرست ناموفق بود. لطفاً دوباره تلاش کنید.' : 'در حال دریافت فهرست...' }}</p></div></ng-template>
    </section>
  </div>
</main>

<ng-template #detailsDialogTemplate let-modal>
  <div class="modal-body p-0 edit-modal-body">
    <app-specialist-registration [editId]="tankerProfile.iPreregistration" [embedded]="true" (savedEdit)="refreshRegistrations()" (closeEdit)="modal.close()"></app-specialist-registration>
  </div>
</ng-template>
